module.exports = __webpack_public_path__ + "static/media/icon-catalog-slabs.64f11e39.svg";